import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { Link, Title, TitleIcon, TitleWrapper, Wrapper } from "./Styles";

OurMission.propTypes = {
  show: PropTypes.bool,
};

export default function OurMission({ show }) {
  if (!show) return null;

  return (
    <StyledWrapper>
      <TitleWrapper>
        <TitleIcon>
          <i className="far fa-compass" />
        </TitleIcon>
        <Title>Our Mission</Title>
      </TitleWrapper>
      <StyledLink
        href="https://flocknote.com/our-mission/"
        target="_blank"
        rel="noreferrer"
      >
        Flocknote&apos;s Guiding Principles &gt;
      </StyledLink>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  margin-top: -14px;
  background-color: none;
  box-shadow: none;
`;

const StyledLink = styled(Link)`
  margin-top: 0;
  font-size: 14px;
`;
